/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { Container, Typography } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTablen from "../../../components/Table/ThemeTablen";
import CommonContext from "../../../hooks/commonContext";
import { getFormatedTime, getTimeZoneDate } from "../../../services/helpers";
import {
  archiveIssueApi,
  closeIssueApi,
  getOneIssue,
  reOpenIssue,
} from "../../../services/apiservices/issues.js";
import { DetailsColumns } from "../IssuesManageTableColumns";
import confirm from "../../../components/DialogComponent/confirm";
import EscalateForm from "./EscalateForm";
import ViewAttachments from "./ViewAttachments";
import { getCompanyClients } from "../../../services/apiservices/client.js";
import { getCompanyUsers } from "../../../services/apiservices/employee.js";
import { useMediaQuery } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import { getSettings } from "../../../services/apiservices/settings.js";
import AuthContext from "../../../hooks/authContext.js";
import { Avatar, AvatarFallback } from "../../../components/ui/avtar.jsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card.jsx";
import { Archive } from "lucide-react";
import { Button } from "../../../components/ui/button.jsx";
import { useToast } from "../../../hooks/useToast.js";
import { trackEvent, CMS_EVENTS } from "../../../services/apiservices/analytics";

function IssueDetails(props) {
  let history = useNavigate();
  const { issueId } = useParams();
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const [IssueDetail, setIssueDetail] = useState([]);
  const [issueSettingRes, setIssueSettingRes] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const { toast } = useToast();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const handleMouseOver = (responseItem) => {
    setShowTooltip(responseItem);
  };

  const handleMouseLeave = () => {
    setShowTooltip(null);
  };

  // const Emails = [
  //   "damon@procleanings.com",
  //   "hazel@procleanings.com",
  //   "nina@procleanings.com",
  // ];

  const fetchIssuesDetails = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);

      try {
        const [clientsRes, employeesRes, issueSettingRes] = await Promise.all([
          new Promise((resolve) =>
            getCompanyClients(companyId, (res) => resolve(res || []))
          ),
          new Promise((resolve) => getCompanyUsers(companyId, (res) => resolve(res || []))),
          new Promise((resolve) =>
            getSettings("issue_settings", companyId, (data) => {
              resolve(data);
            })
          ),
        ]);

        const filteredData =
          issueSettingRes?.data?.filter(
            (item) => !item.deleted
          ) || [];
        setIssueSettingRes(filteredData);
        const roles = filteredData?.[0]?.internamManagersRoles || [];
        const client = clientsRes?.data || [];
        const employeesData = employeesRes?.data || [];
        const InActive = employeesData?.filter(
          (item) => item.status === false || item.deleted
        );
        const AllEmpEmails = employeesData?.filter(
          (item) =>
            item.status !== false &&
            !item.deleted
        );

        let filteredEmployees = [];

        if (roles?.includes("admin") && roles?.includes("support")) {
          filteredEmployees = employeesData?.filter((emp) => emp?.employeerole === "Admin" || emp?.employeerole?.toLowerCase() === "support");
        } else if (roles?.includes("admin")) {
          filteredEmployees = employeesData?.filter((emp) => emp?.employeerole === "Admin");
        } else if (roles?.includes("support")) {
          filteredEmployees = employeesData?.filter((emp) => emp?.employeerole?.toLowerCase() === "support");
        }

        filteredEmployees = filteredEmployees?.filter((emp) => emp?.status !== false && !emp?.deleted);

        const Emails = Array.from(new Set(filteredEmployees?.map((emp) => emp?.email)?.filter(Boolean)));

        const employee = AllEmpEmails?.filter((emp) => Emails?.includes(emp.email));

        const issueRes = await new Promise((resolve, reject) =>
          getOneIssue(issueId, (data, error) => {
            if (error) reject(error);
            else resolve(data);
          })
        );

        if (issueRes && issueRes.status === true && issueRes.data) {
          const matchedClient = client?.find(
            (cl) => cl.id === issueRes.data?.client?.id
          );
          let emails = matchedClient ? [matchedClient.contact[0]?.email] : [];

          const finalEmailsData =
            issueRes.data?.email?.filter(
              (item) =>
                !employeesData.some(
                  (emp) => emp?.email === item && emp?.status === false
                )
            ) || [];

          let matchedEmployee;
          if (issueRes.data?.employee?.id) {
            matchedEmployee = employeesData.find(
              (emp) => emp?.id === issueRes.data?.employee?.id
            );
            if (
              matchedEmployee &&
              matchedEmployee?.status !== false &&
              !matchedEmployee?.deleted
            ) {
              finalEmailsData.push(matchedEmployee?.email);
            }
          }

          const details = {
            ...issueRes.data,
            issuueId: `IS - ${String(issueRes.data?.issueNumber)
              .match(/\d+/)?.[0]
              .padStart(4, "0")}`,
            employeeName: issueRes.data?.employee?.name,
            clientName: issueRes.data?.client?.name,
            dateOfRequest: issueRes.data?.dateOfRequest,
            clientData: emails,
            clientsDetails: [matchedClient],
            employeeData: employee,
            AllEmpEmails: AllEmpEmails,
            newEmails: employeesData,
            finalEmailsData: finalEmailsData,
            inactive: InActive,
            timeZone: matchedEmployee?.timeZone
              ? matchedEmployee?.timeZone
              : "America/New_York",
            issueSettingRes: filteredData,
            createdByEmail: matchedEmployee?.email,
            Emails: Emails
          };

          let responses = details?.responses
            ? [...Object.keys(details?.responses)].map((key) => ({
              ...details?.responses[key],
              id: key,
            }))
            : [];
          responses = responses.sort((a, b) =>
            a.respondOn > b.respondOn ? 1 : -1
          );

          setIssueDetail({ ...details, responses });
        } else {
          throw new Error("Issue data not found or invalid response.");
        }
      } catch (error) {
        console.error("Error fetching issue details:", error);
      } finally {
        commonContext?.setLoader(false);
        trackEvent(CMS_EVENTS.ISSUE_VIEWED, {
          issue_id: issueId,
          issue_number: IssueDetail?.issueNumber,
          client_name: IssueDetail?.clientName
        });
      }
    }
  };
  useEffect(() => {
    fetchIssuesDetails();
  }, [issueId]);

  const getEmailDisplay = (item) => {
    if (item?.escalatedTo && item?.escalated === "Respond from Email") {
      return (
        <div
          className={`d-flex ${isMobile || isLandscape ? "flex-start mb-0" : "flex-center mb-8"
            }`}
          style={{ overflowWrap: "anywhere", fontStyle: "normal" }}
        >
          <div>
            <MailIcon
              style={{ fontSize: 16, verticalAlign: "middle", color: "gray" }}
            />
          </div>
          <span
            className={isMobile ? "ml-5 mt-4" : "ml-5"}
            style={{ color: "blue", width: "90%", lineHeight: "20px" }}
          >
            {item?.respondBy?.email}
          </span>
        </div>
      );
    }
    return (
      <p
        className={isMobile ? "color-newBlack dark:text-white" : "color-newBlack dark:text-white mb-8"}
        style={{ fontSize: "16px", fontWeight: "500", fontStyle: "normal" }}
      >
        {item?.respondBy?.name}
      </p>
    );
  };

  const closeIssue = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);
      const email = IssueDetail?.finalEmailsData?.length > 0 ? IssueDetail?.finalEmailsData : [IssueDetail?.createdByEmail];
      await closeIssueApi(
        issueId,
        IssueDetail?.issueNumberInt,
        email,
        IssueDetail?.createdBy,
        (res) => {
          commonContext?.setLoader(false);
          trackEvent(CMS_EVENTS.ISSUE_CLOSED, {
            issue_id: issueId,
            issue_number: IssueDetail?.issueNumber,
            action: "closed"
          });
          history("/operations/issues/manage");
          toast?.({ title: "Success", description: "Issue Close Successfully" });
        },
        (resError) => {
          commonContext?.setLoader(false);
          toast?.({
            title: "destructive",
            description: "Failed to close issue",
          });
        }
      );
    }
  };

  const archiveIssue = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);
      const email = IssueDetail?.finalEmailsData?.length > 0 ? IssueDetail?.finalEmailsData : [IssueDetail?.createdByEmail];
      await archiveIssueApi(
        issueId,
        IssueDetail?.issueNumberInt,
        email,
        IssueDetail?.createdBy,
        (res) => {
          commonContext?.setLoader(false);
          trackEvent(CMS_EVENTS.ISSUE_CLOSED, {
            issue_id: issueId,
            issue_number: IssueDetail?.issueNumber,
            action: "archived"
          });
          history("/operations/issues/manage");
          toast?.({ title: "Success", description: "Issue Archive Successfully" });
        },
        (resError) => {
          commonContext?.setLoader(false);
          toast?.({
            title: "destructive",
            description: "Failed to archive issue",
          });
        }
      );
    }
  };

  const ReOpenIssue = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);
      const email = IssueDetail?.finalEmailsData?.length > 0 ? IssueDetail?.finalEmailsData : [IssueDetail?.createdByEmail];
      await reOpenIssue(
        issueId,
        IssueDetail?.issueNumberInt,
        email,
        IssueDetail?.createdBy,
        (res) => {
          commonContext?.setLoader(false);
          history("/operations/issues/manage");
          toast?.({ title: "Success", description: "Issue Re-Open Successfully" });
        },
        (resError) => {
          commonContext?.setLoader(false);
          toast?.({
            title: "destructive",
            description: "Failed to Re-Open issue",
          });
        }
      );
    }
  };

  const OnClickCloseIssue = async () => {
    await confirm("All users on this thread will see this issue as closed.").then(
      () => {
        closeIssue();
        console.log("close issue");
      },
      () => console.log("cancel!")
    );
  };

  const OnClickArchiveIssue = async () => {
    await confirm("Are you sure you want to archive this issue?").then(
      () => {
        archiveIssue();
        console.log("archive issue");
      },
      () => console.log("cancel!")
    );
  };

  const OnClickReOpenIssue = async () => {
    await confirm("Are you sure you want to Re-open this issue?").then(
      () => {
        ReOpenIssue();
        console.log("Re-open issue");
      },
      () => console.log("cancel!")
    );
  };

  return (
    <Container>
      <PageTitle
        pageTitle="Issue Management Detail"
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Issue Manage", to: "/operations/issues/manage" },
        ]}
        BreadCrumbCurrentPageTitle={"Edit Issue"}
      />

      <div className={isMobile ? "pv-20 ph-15" : "p-24"}>
        <div
          style={{
            maxWidth: isMobile ? "400px" : "1280px",
            margin: "0px auto",
          }}
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-bold flex items-center gap-2">
                <span className="dark:text-white">{IssueDetail?.issuueId}</span>
                {IssueDetail?.escalated_to_admin === true && (
                  <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
                    Escalated
                  </span>
                )}
              </h1>
              <p className="text-muted-foreground">
                {IssueDetail?.description}
              </p>
            </div>
            <div className="flex items-center gap-2">
              {!IssueDetail || IssueDetail?.status === undefined ? null : IssueDetail?.status === "Closed" ? (
                <>
                  <Button
                    variant="outline"
                    className={
                      "text-amber-600 border-amber-200 hover:bg-amber-50 hover:text-amber-700"
                    }
                    onClick={() => OnClickReOpenIssue()}
                  // disabled={
                  //   issueSettingRes
                  //     ? issueSettingRes?.[0] &&
                  //       !issueSettingRes?.[0]?.archiveRequestRole?.includes(
                  //         auth?.userProfile?.role
                  //       )
                  //     : false
                  // }
                  >
                    <Archive className="mr-2 h-4 w-4" />
                    Re-Open Issue
                  </Button>
                  <Button
                    variant="outline"
                    className={
                      "text-amber-600 border-amber-200 hover:bg-amber-50 hover:text-amber-700"
                    }
                    onClick={() => OnClickArchiveIssue()}
                  // disabled={
                  //   issueSettingRes
                  //     ? issueSettingRes?.[0] &&
                  //       !issueSettingRes?.[0]?.archiveRequestRole?.includes(
                  //         auth?.userProfile?.role
                  //       )
                  //     : false
                  // }
                  >
                    <Archive className="mr-2 h-4 w-4" />
                    Archive Issue
                  </Button>
                </>
              ) : (
                <Button
                  variant="outline"
                  className={
                    "text-amber-600 border-amber-200 hover:bg-amber-50 hover:text-amber-700"
                  }
                  onClick={() => OnClickCloseIssue()}
                // disabled={
                //   issueSettingRes
                //     ? issueSettingRes?.[0] &&
                //       !issueSettingRes?.[0]?.archiveRequestRole?.includes(
                //         auth?.userProfile?.role
                //       )
                //     : false
                // }
                >
                  Close Issue
                </Button>
              )}
            </div>
          </div>

          <ThemeTablen
            rows={[IssueDetail]}
            headCells={DetailsColumns}
            hidePagination={true}
          />

          <Card className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader className="p-24">
              <CardTitle className="text-xl">Comments & Activity</CardTitle>
            </CardHeader>
            <CardContent className="pt-0 ph-24 pb-24">
              {IssueDetail?.status !== "Closed" && (
                <EscalateForm
                  IssueDetail={IssueDetail}
                  fetchIssuesDetails={fetchIssuesDetails}
                />
              )}
              <div className="alertselect">
                <div className="issueDetails mb-20">
                  {IssueDetail?.responses &&
                    IssueDetail?.responses
                      ?.sort((a, b) => b?.respondOn - a?.respondOn)
                      ?.map((responseItem, index) => {
                        return (
                          <div
                            key={index}
                            className=" d-flex mb-15 bg-slate-50 rounded-lg p-16 position-relative gap-4 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                          >
                            <div className="flex items-start">
                              <Avatar className="h-10 w-10 border">
                                <AvatarFallback className="bg-purple-100 text-purple-800">
                                  {responseItem?.respondBy?.name
                                    .split(" ")
                                    .map((name) => name[0])
                                    .join("")
                                    .toUpperCase()}
                                </AvatarFallback>
                              </Avatar>
                            </div>
                            <div className="w-100">
                              <Typography
                                variant="subtitle1"
                                style={{ fontStyle: "normal" }}
                              >
                                <div className={isMobile ? "mb-8" : ""}>
                                  {responseItem?.escalatedTo ? (
                                    <div
                                      className={
                                        isMobile
                                          ? "d-flex flex-direction-column"
                                          : "d-flex flex-space-between"
                                      }
                                    >
                                      <span
                                        className={isMobile ? "W-100" : "w-65"}
                                      >
                                        {getEmailDisplay(responseItem)}
                                      </span>{" "}
                                      <span
                                        className="w-20"
                                        style={{
                                          color: "#6B7280",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {getTimeZoneDate(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}{" "}
                                        {getFormatedTime(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}
                                      </span>
                                    </div>
                                  ) : (
                                    <div
                                      className={
                                        isMobile
                                          ? "d-flex flex-direction-column"
                                          : "d-flex flex-space-between"
                                      }
                                    >
                                      <span
                                        className={isMobile ? "W-100" : "w-65"}
                                      >
                                        {getEmailDisplay(responseItem)}
                                      </span>{" "}
                                      <span
                                        className="w-20"
                                        style={{
                                          color: "#6B7280",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {getTimeZoneDate(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}{" "}
                                        {getFormatedTime(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </Typography>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    responseItem?.escalatedTo &&
                                      responseItem?.escalated ===
                                      "Respond from Email"
                                      ? responseItem?.details
                                        ?.split("On")[0]
                                        ?.trim()
                                        ?.replace(/<[^>]*>/g, "")
                                        ?.replace(/(\d+\.\s?)/g, "<br>$1")
                                      : responseItem?.description
                                        ?.replace(/<[^>]*>/g, "")
                                        ?.replace(/(\d+\.\s?)/g, "<br>$1"),
                                }}
                                className="mb-12 text-[#1F2937] dark:text-[#6B7280]"
                                style={{
                                  fontSize: "14px",
                                  // color: "#1F2937",
                                  fontWeight: "500",
                                }}
                              ></div>
                              <div className="d-flex flex-space-between flex-end">
                                {/* <div
                            className="issuelink"
                            onMouseOver={() => handleMouseOver(responseItem)}
                            onMouseLeave={handleMouseLeave}
                          >
                            Included Recipients(
                            {responseItem?.recipients?.length || 0})
                          </div>
                          {showTooltip === responseItem && (
                            <>
                              {responseItem?.recipients?.length > 0 ? (
                                <>
                                  <RecipientsTooltip
                                    recipients={responseItem.recipients}
                                    styles={styles}
                                  />
                                </>
                              ) : null}
                            </>
                          )} */}
                                <div className="mt-8">
                                  <button
                                    className="text-xs text-blue-600 hover:text-blue-800"
                                    onClick={() =>
                                      setShowTooltip(
                                        showTooltip === false
                                          ? responseItem
                                          : false
                                      )
                                    }
                                  >
                                    {showTooltip === responseItem
                                      ? "Hide recipients"
                                      : "Show recipients"}
                                  </button>

                                  {showTooltip === responseItem && (
                                    <div className="mt-8 text-xs text-gray-500 bg-gray-100 p-8 rounded">
                                      <strong>Recipients:</strong>{" "}
                                      {responseItem?.recipients?.join(", ")}
                                    </div>
                                  )}
                                </div>
                                <div
                                  style={{
                                    width: isMobile || isLandscape ? "40%" : "",
                                  }}
                                >
                                  <ViewAttachments
                                    attachments={responseItem?.attachments}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default IssueDetails;
